// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root___J2Zp","header":"PatientQuestionnaire_header__2UzTF","info":"PatientQuestionnaire_info__23C2-"};